module.exports = __webpack_public_path__ + "static/wpe-hero-full-a36ac84eb4afa8d15c86460c24c1967d.jpg";